export default __webpack_public_path__ + "b92082bc61d6fb5e86d19279daf5f908.png";